<h4 class="text-danger">There has been an error.</h4>
<p *ngIf="message">{{message}}</p>

<div *nzModalFooter>
  <button class="btn btn-theme btn-sm me-2" (click)="destroyModal()">Close</button>
</div>
